import { api } from "../../api/client.js";
import type { Project } from "../../api/types.js";

export async function createProject(name: string) {
  const data = await api<{ project: Project }>("/api/projects", {
    method: "POST",
    body: JSON.stringify({ name })
  });
  return data.project;
}

export async function renameProject(projectId: string, name: string) {
  const data = await api<{ project: Project }>(`/api/projects/${projectId}`, {
    method: "PATCH",
    body: JSON.stringify({ name })
  });
  return data.project;
}

export async function deleteProject(projectId: string) {
  await api(`/api/projects/${projectId}`, { method: "DELETE" });
}
